/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createUser = /* GraphQL */ `mutation CreateUser(
  $username: String!
  $lastname: String!
  $password: String!
  $email: String!
  $role: String!
) {
  createUser(
    username: $username
    lastname: $lastname
    password: $password
    email: $email
    role: $role
  ) {
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const processFile = /* GraphQL */ `mutation ProcessFile(
  $BucketName: String
  $TableName: String
  $Key: String
  $RequestID: String
  $RequestDate: String
  $Mapper: [FieldMapper]
) {
  processFile(
    BucketName: $BucketName
    TableName: $TableName
    Key: $Key
    RequestID: $RequestID
    RequestDate: $RequestDate
    Mapper: $Mapper
  )
}
` as GeneratedMutation<
  APITypes.ProcessFileMutationVariables,
  APITypes.ProcessFileMutation
>;
export const uploadFile = /* GraphQL */ `mutation UploadFile(
  $key: String!
  $user_name: String!
  $file_category: String!
  $file_type: String!
) {
  uploadFile(
    key: $key
    user_name: $user_name
    file_category: $file_category
    file_type: $file_type
  )
}
` as GeneratedMutation<
  APITypes.UploadFileMutationVariables,
  APITypes.UploadFileMutation
>;
export const InvokeBatchUpload =
  /* GraphQL */ `mutation InvokeBatchUpload($step_function: String!, $batch_data: BatchData!) {
  InvokeBatchUpload(step_function: $step_function, batch_data: $batch_data)
}
` as GeneratedMutation<
  APITypes.InvokeBatchUploadMutationVariables,
  APITypes.InvokeBatchUploadMutation
>;
export const InvokeFileProcessSfns =
  /* GraphQL */ `mutation InvokeFileProcessSfns(
  $step_function: String!
  $batch_data: FileUploadData!
) {
  InvokeFileProcessSfns(step_function: $step_function, batch_data: $batch_data)
}
` as GeneratedMutation<
  APITypes.InvokeFileProcessSfnsMutationVariables,
  APITypes.InvokeFileProcessSfnsMutation
>;
export const MarkBatchProgressByUser =
  /* GraphQL */ `mutation MarkBatchProgressByUser(
  $username: String!
  $batch_id: String!
  $tobe_labeled_item_id: Int
  $labeled_items_count: Int
) {
  MarkBatchProgressByUser(
    username: $username
    batch_id: $batch_id
    tobe_labeled_item_id: $tobe_labeled_item_id
    labeled_items_count: $labeled_items_count
  )
}
` as GeneratedMutation<
  APITypes.MarkBatchProgressByUserMutationVariables,
  APITypes.MarkBatchProgressByUserMutation
>;
export const MarkBatchCompletionByUser =
  /* GraphQL */ `mutation MarkBatchCompletionByUser($username: String!, $batch_id: String) {
  MarkBatchCompletionByUser(username: $username, batch_id: $batch_id)
}
` as GeneratedMutation<
  APITypes.MarkBatchCompletionByUserMutationVariables,
  APITypes.MarkBatchCompletionByUserMutation
>;
export const CreateUserGroup = /* GraphQL */ `mutation CreateUserGroup(
  $name: String!
  $users: [CreateUserGroupData]!
  $created_at: String
  $created_by: String
) {
  CreateUserGroup(
    name: $name
    users: $users
    created_at: $created_at
    created_by: $created_by
  )
}
` as GeneratedMutation<
  APITypes.CreateUserGroupMutationVariables,
  APITypes.CreateUserGroupMutation
>;
export const CaptureLabelingResult =
  /* GraphQL */ `mutation CaptureLabelingResult(
  $batch_id: String!
  $batch_item_id: Int!
  $username: String!
  $given_answer: String!
) {
  CaptureLabelingResult(
    batch_id: $batch_id
    batch_item_id: $batch_item_id
    username: $username
    given_answer: $given_answer
  )
}
` as GeneratedMutation<
  APITypes.CaptureLabelingResultMutationVariables,
  APITypes.CaptureLabelingResultMutation
>;
export const AddUserToLabelFile = /* GraphQL */ `mutation AddUserToLabelFile(
  $username: String!
  $labelFileId: String!
  $labelFileName: String!
  $totalRecords: Int!
  $priorityLevel: Int!
) {
  AddUserToLabelFile(
    username: $username
    labelFileId: $labelFileId
    labelFileName: $labelFileName
    totalRecords: $totalRecords
    priorityLevel: $priorityLevel
  ) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddUserToLabelFileMutationVariables,
  APITypes.AddUserToLabelFileMutation
>;

export const RemoveLabelFileData =
  /* GraphQL */ `mutation RemoveLabelFileData($assignedUsers: [String]!, $labelFileId: String!) {
  RemoveLabelFileData(
    assignedUsers: $assignedUsers
    labelFileId: $labelFileId
  ) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RemoveLabelFileDataMutationVariables,
  APITypes.RemoveLabelFileDataMutation
>;
export const startBenchmark = /* GraphQL */ `mutation StartBenchmark(
  $benchmarkName: String!
  $modelId: String!
  $jobId: String!
) {
  startBenchmark(
    benchmarkName: $benchmarkName
    modelId: $modelId
    jobId: $jobId
  ) {
    executionArn
    jobId
    status
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.StartBenchmarkMutationVariables,
  APITypes.StartBenchmarkMutation
>;
export const UploadModel = /* GraphQL */ `mutation UploadModel(
  $desc: String
  $link: String
  $name: String!
  $embedding_model: String
  $s3_uri: String!
  $status: String!
  $time: String
  $type: String!
  $id: String!
  $userName: String!
  $deployed_status: Boolean
) {
  UploadModel(
    desc: $desc
    link: $link
    name: $name
    embedding_model: $embedding_model
    s3_uri: $s3_uri
    status: $status
    time: $time
    type: $type
    id: $id
    userName: $userName
    deployed_status: $deployed_status
  ) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UploadModelMutationVariables,
  APITypes.UploadModelMutation
>;
export const updateModelData = /* GraphQL */ `mutation UpdateModelData(
  $id: String!
  $desc: String
  $link: String
  $name: String
  $embedding_model: String
  $s3_uri: String
  $status: String
  $type: String
  $deployed_status: Boolean
) {
  updateModelData(
    id: $id
    desc: $desc
    link: $link
    name: $name
    embedding_model: $embedding_model
    s3_uri: $s3_uri
    status: $status
    type: $type
    deployed_status: $deployed_status
  ) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateModelDataMutationVariables,
  APITypes.UpdateModelDataMutation
>;
export const deleteModelData =
  /* GraphQL */ `mutation DeleteModelData($id: String!) {
  deleteModelData(id: $id) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteModelDataMutationVariables,
  APITypes.DeleteModelDataMutation
>;
export const addBenchmarkData = /* GraphQL */ `mutation AddBenchmarkData(
  $name: String!
  $code: String!
  $config_path: String
  $configs: AWSJSON
  $metrics: String!
  $type: String!
  $desc: String!
) {
  addBenchmarkData(
    name: $name
    code: $code
    config_path: $config_path
    configs: $configs
    metrics: $metrics
    type: $type
    desc: $desc
  ) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddBenchmarkDataMutationVariables,
  APITypes.AddBenchmarkDataMutation
>;
export const updateBenchmarkData = /* GraphQL */ `mutation UpdateBenchmarkData(
  $name: String!
  $code: String!
  $config_path: String
  $configs: AWSJSON
  $metrics: String!
  $type: String!
  $desc: String!
) {
  updateBenchmarkData(
    name: $name
    code: $code
    config_path: $config_path
    configs: $configs
    metrics: $metrics
    type: $type
    desc: $desc
  ) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBenchmarkDataMutationVariables,
  APITypes.UpdateBenchmarkDataMutation
>;
export const updateCompatibleModel =
  /* GraphQL */ `mutation UpdateCompatibleModel($display_name: String!, $is_online: Boolean) {
  updateCompatibleModel(display_name: $display_name, is_online: $is_online) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCompatibleModelMutationVariables,
  APITypes.UpdateCompatibleModelMutation
>;
export const deleteBenchmarkData =
  /* GraphQL */ `mutation DeleteBenchmarkData($code: String!) {
  deleteBenchmarkData(code: $code) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBenchmarkDataMutationVariables,
  APITypes.DeleteBenchmarkDataMutation
>;
export const addAudit = /* GraphQL */ `mutation AddAudit($audit: AuditData) {
  addAudit(audit: $audit) {
    code
    msg
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddAuditMutationVariables,
  APITypes.AddAuditMutation
>;
export const executePipeline = /* GraphQL */ `mutation ExecutePipeline(
  $service: String!
  $operation: String!
  $request: PipelineData
) {
  executePipeline(service: $service, operation: $operation, request: $request)
}
` as GeneratedMutation<
  APITypes.ExecutePipelineMutationVariables,
  APITypes.ExecutePipelineMutation
>;
export const deleteUserGroupById =
  /* GraphQL */ `mutation DeleteUserGroupById($userGroupId: String!) {
  deleteUserGroupById(userGroupId: $userGroupId) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserGroupByIdMutationVariables,
  APITypes.DeleteUserGroupByIdMutation
>;
export const manageEnvironments =
  /* GraphQL */ `mutation ManageEnvironments($prefix: String, $action: String!, $startTime: String, $endTime: String, $account_id: String) {
  manageEnvironments(prefix: $prefix, action: $action, startTime: $startTime, endTime: $endTime, account_id: $account_id)
}
` as GeneratedMutation<
  APITypes.ManageEnvironmentsMutationVariables,
  APITypes.ManageEnvironmentsMutation
>;

export const updateMixingData =
  /* GraphQL */ `mutation UpdateMixingData($table: String!, $ind: Int, $sale: String, $lot: String, $status: String!) {
  updateMixingData(table: $table, ind: $ind, sale: $sale, lot: $lot, status: $status)
}` as GeneratedMutation<
  APITypes.UpdateMixingDataMutationVariables,
  APITypes.UpdateMixingDataMutation
>;

export const RequestMixingLots =
  /* GraphQL */ `mutation RequestMixingLots($user: String!, $sale_code: String!, $count: Int!, $status: String!,$starting_box: Int!, $image_folder: String!, $time: AWSDateTime!, $check_missed: String!) {
  RequestMixingLots(user: $user, sale_code: $sale_code, count: $count, status: $status, starting_box: $starting_box, image_folder: $image_folder, time: $time, check_missed: $check_missed)
}` as GeneratedMutation<
  APITypes.RequestMixingLotsMutationVariables,
  APITypes.RequestMixingLotsMutation
>;

export const updateMixingSummaryStatus =
  /* GraphQL */ `mutation UpdateMixingSummaryStatus($sale_code: String!, $status: String!) {
  updateMixingSummaryStatus(sale_code: $sale_code,  status: $status)
}` as GeneratedMutation<
  APITypes.UpdateMixingSummaryStatusMutationVariables,
  APITypes.UpdateMixingSummaryStatusMutation
>;

export const updateMixingMissingCaptureCompletionStatus =
  /* GraphQL */ `mutation UpdateMixingMissingCaptureCompletionStatus($sale_code: String!, $status: String!) {
  updateMixingMissingCaptureCompletionStatus(sale_code: $sale_code,  status: $status)
}` as GeneratedMutation<
  APITypes.UpdateMixingMissingCaptureCompletionStatusMutationVariables,
  APITypes.UpdateMixingMissingCaptureCompletionStatusMutation
>;

export const updateMixingCollectingStatus =
  /* GraphQL */ `mutation UpdateMixingCollectingStatus($sale_code: String!, $status: String!, $user: String, $count: Int, $time: AWSDateTime) {
  updateMixingCollectingStatus(sale_code: $sale_code,  status: $status, user: $user, count: $count, time: $time)
}` as GeneratedMutation<
  APITypes.UpdateMixingCollectingStatusMutationVariables,
  APITypes.UpdateMixingCollectingStatusMutation
>;

export const updateMixingCompletionStatus =
  /* GraphQL */ `mutation UpdateMixingCompletionStatus($sale_code: String!, $status: String!, $user: String, $count: Int, $time: AWSDateTime) {
  updateMixingCompletionStatus(sale_code: $sale_code,  status: $status, user: $user, count: $count, time: $time)
}` as GeneratedMutation<
  APITypes.UpdateMixingCompletionStatusMutationVariables,
  APITypes.UpdateMixingCompletionStatusMutation
>;
export const editSellingMark =
  /* GraphQL */ `mutation EditSellingMark($selling_mark: String!, $factory_name: String, $factory_code: String, $region: String, $sub_elevation: String, $location: String) {
  editSellingMark(selling_mark: $selling_mark,  factory_name: $factory_name, factory_code: $factory_code, region: $region, sub_elevation: $sub_elevation, location: $location)
}` as GeneratedMutation<
  APITypes.EditSellingMarkMutationVariables,
  APITypes.EditSellingMarkMutation
>;
export const ProcessLabelFile = /* GraphQL */ `mutation ProcessLabelFile(
  $bucket: String!
  $key: String!
  $assignedUsers: [String]!
  $initiatedBy: String!
  $totalRecords: Int!
  $priorityLevel: Int!
) {
  ProcessLabelFile(
    bucket: $bucket
    key: $key
    assignedUsers: $assignedUsers
    initiatedBy: $initiatedBy
    totalRecords: $totalRecords
    priorityLevel: $priorityLevel
  )
}
` as GeneratedMutation<
  APITypes.ProcessLabelFileMutationVariables,
  APITypes.ProcessLabelFileMutation
>;
export const LabelingProcessLabelFile = /* GraphQL */ `mutation LabelingProcessLabelFile(
  $bucket: String!
  $key: String!
  $assignedUsers: [String]!
  $initiatedBy: String!
  $totalRecords: Int!
  $priorityLevel: Int!
  $type: String!
) {
  LabelingProcessLabelFile(
    bucket: $bucket
    key: $key
    assignedUsers: $assignedUsers
    initiatedBy: $initiatedBy
    totalRecords: $totalRecords
    priorityLevel: $priorityLevel
    type: $type
  )
}
` as GeneratedMutation<
  APITypes.LabelingProcessLabelFileMutationVariables,
  APITypes.LabelingProcessLabelFileMutation
>;
export const RemoveLabelFile =
  /* GraphQL */ `mutation RemoveLabelFile($fileId: String!) {
  RemoveLabelFile(fileId: $fileId)
}
` as GeneratedMutation<
  APITypes.RemoveLabelFileMutationVariables,
  APITypes.RemoveLabelFileMutation
>;
export const LabelingRemoveLabelFile =
  /* GraphQL */ `mutation LabelingRemoveLabelFile($fileId: String!) {
  LabelingRemoveLabelFile(fileId: $fileId)
}
` as GeneratedMutation<
  APITypes.LabelingRemoveLabelFileMutationVariables,
  APITypes.LabelingRemoveLabelFileMutation
>;
export const AssignUserToLabelFile =
  /* GraphQL */ `mutation AssignUserToLabelFile($fileId: String!, $username: String!) {
  AssignUserToLabelFile(fileId: $fileId, username: $username)
}
` as GeneratedMutation<
  APITypes.AssignUserToLabelFileMutationVariables,
  APITypes.AssignUserToLabelFileMutation
>;
export const LabelingAssignUserToLabelFile =
  /* GraphQL */ `mutation LabelingAssignUserToLabelFile($fileId: String!, $username: String!) {
  LabelingAssignUserToLabelFile(fileId: $fileId, username: $username)
}
` as GeneratedMutation<
  APITypes.LabelingAssignUserToLabelFileMutationVariables,
  APITypes.LabelingAssignUserToLabelFileMutation
>;
export const RemoveUserFromLabelFile =
  /* GraphQL */ `mutation RemoveUserFromLabelFile($fileId: String!, $username: String!) {
  RemoveUserFromLabelFile(fileId: $fileId, username: $username)
}
` as GeneratedMutation<
  APITypes.RemoveUserFromLabelFileMutationVariables,
  APITypes.RemoveUserFromLabelFileMutation
>;
export const LabelingRemoveUserFromLabelFile =
  /* GraphQL */ `mutation LabelingRemoveUserFromLabelFile($fileId: String!, $username: String!) {
  LabelingRemoveUserFromLabelFile(fileId: $fileId, username: $username)
}
` as GeneratedMutation<
  APITypes.LabelingRemoveUserFromLabelFileMutationVariables,
  APITypes.LabelingRemoveUserFromLabelFileMutation
>;
export const SubmitLabelFileResult =
  /* GraphQL */ `mutation SubmitLabelFileResult(
  $fileId: String!
  $recordId: Int!
  $username: String!
  $results: AWSJSON!
) {
  SubmitLabelFileResult(
    fileId: $fileId
    recordId: $recordId
    username: $username
    results: $results
  )
}
` as GeneratedMutation<
  APITypes.SubmitLabelFileResultMutationVariables,
  APITypes.SubmitLabelFileResultMutation
>;
export const LabelingSubmitLabelFileResult =
  /* GraphQL */ `mutation LabelingSubmitLabelFileResult(
  $fileId: String!
  $recordId: Int!
  $username: String!
  $results: AWSJSON!
) {
  LabelingSubmitLabelFileResult(
    fileId: $fileId
    recordId: $recordId
    username: $username
    results: $results
  )
}
` as GeneratedMutation<
  APITypes.LabelingSubmitLabelFileResultMutationVariables,
  APITypes.LabelingSubmitLabelFileResultMutation
>;
export const SetLabelFileCompletion =
  /* GraphQL */ `mutation SetLabelFileCompletion($fileId: String!) {
  SetLabelFileCompletion(fileId: $fileId)
}
` as GeneratedMutation<
  APITypes.SetLabelFileCompletionMutationVariables,
  APITypes.SetLabelFileCompletionMutation
>;
export const LabelingSetLabelFileCompletion =
  /* GraphQL */ `mutation LabelingSetLabelFileCompletion($fileId: String!) {
  LabelingSetLabelFileCompletion(fileId: $fileId)
}
` as GeneratedMutation<
  APITypes.LabelingSetLabelFileCompletionMutationVariables,
  APITypes.LabelingSetLabelFileCompletionMutation
>;

export const saveAnnotations = /* GraphQL */ `mutation SaveAnnotations(
  $annotation_files_id: Int!
  $annotation_file_records_id: Int!
  $user_name: String!
  $status: String!
  $annotations: [AnnotationInput!]!
) {
  saveAnnotations(
    annotation_files_id: $annotation_files_id
    annotation_file_records_id: $annotation_file_records_id
    user_name: $user_name
    status: $status
    annotations: $annotations
  )
}
` as GeneratedMutation<
  APITypes.SaveAnnotationsMutationVariables,
  APITypes.SaveAnnotationsMutation
>;

export const deleteAnnotationResult = /* GraphQL */ `mutation DeleteAnnotationResult(
  $resultId: Int!
  $userName: String!
) {
  deleteAnnotationResult(resultId: $resultId, userName: $userName)
}
` as GeneratedMutation<
  APITypes.DeleteAnnotationResultMutationVariables,
  APITypes.DeleteAnnotationResultMutation
>;

export const createAnnotationLabel =
  /* GraphQL */ `mutation CreateAnnotationLabel(
  $name: String!
  $color: String!
) {
  createAnnotationLabel(
    name: $name
    color: $color
  ) {
    id
    name
    color
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAnnotationLabelMutationVariables,
  APITypes.CreateAnnotationLabelMutation
>;

export const createAnnotationJob = /* GraphQL */ `mutation CreateAnnotationJob(
  $name: String!
  $s3FileKey: String!
  $assignedUsers: [String]!
  $assignedBy: String!
  $allowedLabelIds: [Int]
) {
  createAnnotationJob(
    name: $name
    s3FileKey: $s3FileKey
    assignedUsers: $assignedUsers
    assignedBy: $assignedBy
    allowedLabelIds: $allowedLabelIds
  )
}
` as GeneratedMutation<
  APITypes.CreateAnnotationJobMutationVariables,
  APITypes.CreateAnnotationJobMutation
>;
export const deleteAnnotationJob = /* GraphQL */ `mutation DeleteAnnotationJob(
  $jobId: Int!
) {
  deleteAnnotationJob(jobId: $jobId)
}
` as GeneratedMutation<
  APITypes.DeleteAnnotationJobMutationVariables,
  APITypes.DeleteAnnotationJobMutation
>;

export const processCatalogTextFile = /* GraphQL */ `mutation ProcessCatalogTextFile(
  $BucketName: String!
  $Key: String!
  $Year: Int!
  $Week: Int!
  $Broker: String!
  $RequestID: String
) {
  processCatalogTextFile(
    BucketName: $BucketName
    Key: $Key
    Year: $Year
    Week: $Week
    Broker: $Broker
    RequestID: $RequestID
  )
}`;

